import { RadarEventType, Sentiment } from 'graphql/generated';
import { theme } from 'styles/theme';

export const eventTypeLabelMap = {
  [RadarEventType.Ugc]: 'Brand mentions in UGC',
  [RadarEventType.Comment]: 'Brand mentions in comments',
  [RadarEventType.Engagement]: 'Brand engagement',
  [RadarEventType.Moment]: 'Personal moments',
};

export const eventTypeTooltipMap = {
  [RadarEventType.Engagement]: 'Comments only',
};

export const SentimentOptions = {
  [Sentiment.Positive]: {
    label: 'Positive',
    sx: {
      color: theme.colors?.utility['green-4'],
      backgroundColor: 'rgba(224, 228, 202, 0.50)',
    },
  },
  [Sentiment.Neutral]: {
    label: 'Neutral',
    sx: {
      color: theme.colors?.utility['yellow-4'],
      backgroundColor: 'rgba(255, 245, 204, 0.50)',
    },
  },
  [Sentiment.Negative]: {
    label: 'Negative',
    sx: {
      color: theme.colors?.utility['red-4'],
      backgroundColor: 'rgba(255, 224, 204, 0.50)',
    },
  },
};
